import { addDays, differenceInCalendarDays, isAfter } from 'date-fns';

export interface CalculateCurrentEndDateRangeAvailableProps {
  firstInstanceStartDate: Date;
  firstInstanceEndDate: Date;
  currentCycleStartDate: Date;
  currentCycleEndDate: Date;
}

export function calculateCurrentEndDateRangeAvailability({
  firstInstanceStartDate,
  firstInstanceEndDate,
  currentCycleStartDate,
  currentCycleEndDate,
}: CalculateCurrentEndDateRangeAvailableProps): Date {
  const diffInDays = differenceInCalendarDays(
    firstInstanceEndDate,
    firstInstanceStartDate
  );

  const currentEndDateRange = addDays(currentCycleStartDate, diffInDays);

  return isAfter(currentEndDateRange, currentCycleEndDate)
    ? currentCycleEndDate
    : currentEndDateRange;
}
